<template>
  <div
    id="close"
    :style="cssVars"
  >
    <div @click="$emit('close')">
      <span
        v-text="type === 'close' ? 'x' : '-'"
        :title="type === 'close' ? 'Fechar' : 'Minimizar'"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

defineEmits(['close']);
const props = defineProps<{
  top: string,
  right: string,
  size: string,
  type: 'minimize' | 'close'
}>();

const cssVars = computed(() => {
  return {
    ['--top']: props.top,
    ['--right']: props.right,
    ['--size']: props.size,
  };
});
</script>

<style scoped lang="scss">
div#close {
  position: absolute;
  top: var(--top);
  right: var(--right);

  &>div {
    position: fixed;
    z-index: 1;
    width: var(--size);
    height: var(--size);
    border-radius: 50%;
    display: flex;
    font-size: 0.7em;
    line-height: 0.7em;
    background-color: rgba(233, 225, 225, 1);
    cursor: pointer;

    span {
      margin: auto;
      color: black;
      opacity: 0.75;
    }
  }
}
</style>